/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Button, HFlow, Text, Theme, Tooltip, useTheme } from 'bold-ui'
import { gray, purple } from 'bold-ui/lib/styles/colors'
import preNatalImage from 'images/soap/ic_pre-natal.png'
import { useMemo } from 'react'

interface PreNatalObjetivoButtonProps {
  isSelecionado: boolean
  handleClick(): void
  tooltipText?: string
  disabled?: boolean
}

export function PreNatalButton(props: PreNatalObjetivoButtonProps) {
  const { isSelecionado, handleClick, tooltipText, disabled } = props

  const theme = useTheme()
  const styles = useMemo(() => createStyles(isSelecionado, theme), [isSelecionado, theme])

  return (
    <Tooltip text={tooltipText}>
      <Button size='medium' onClick={handleClick} style={styles.button} disabled={disabled} data-testid='botaoPreNatal'>
        <HFlow alignItems='center' hSpacing={0.5}>
          <img src={preNatalImage} alt='Pré-natal' />
          <Text fontWeight='bold' style={styles.text}>
            Pré-natal
          </Text>
        </HFlow>
      </Button>
    </Tooltip>
  )
}

const createStyles = (isSelecionado: boolean, theme: Theme) => ({
  button: css`
    width: 9.75rem;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    background-color: ${isSelecionado ? purple.c60 : gray.c100};
    border: ${isSelecionado ? '0' : `1px ${purple.c60} solid`};
    border-radius: 2px;
    &:not(:disabled):hover {
      background-color: ${isSelecionado ? purple.c50 : purple.c90};
      border-color: ${isSelecionado ? purple.c50 : purple.c60};
    }
  `,
  text: css`
    color: ${isSelecionado ? theme.pallete.gray.c100 : purple.c40};
  `,
})
